/*
 * @Description: 视频展示组件
 * @Author: he.jianbo
 * @Date: 2019-10-30 17:50:46
 * @LastEditTime: 2019-10-31 18:16:58
 * @LastEditors: he.jianbo
 */

angular.module('weiboVideoViewModule', []).directive('weiboVideoView', [
    '$q',
    'trsHttpService',
    function($q, trsHttpService) {
        return {
            scope: {
                video: '=',
                isVideo: '=',
                videoId: '=',
            },
            restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
            templateUrl: './editingCenter/weibo/directive/videoView/videoView_tpl.html',
            replace: false,
            link: function($scope, iElm, iAttrs, controller) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        showVideo: false,
                    };
                }

                /**
                 * [initData 初始化数据]
                 *
                 * @return  {[type]}
                 *   [return description]
                 */
                function initData() {
                    // 内部方法

                    /**
                     * [getVideoUrl 获取转码后的视频地址]
                     *
                     * @param  {[type]}  id
                     *   [id description]
                     *
                     * @return  {[type]}
                     *   [return description]
                     */
                    function getVideoUrl() {
                        var checkTimeout = 1000;
                        var timerId = setInterval(() => {
                            if (!$scope.videoId) {
                                return;
                            }
                            var params = {
                                serviceid: 'mlf_videoInterfacesEncapsulation',
                                methodname: 'getVideoInfoAndUpdate',
                                audioVideoId: $scope.videoId,
                                plateFormFlag: 'BDVideoObject',
                            };
                            if ($scope.video && $scope.video.indexOf('mp4') === -1) {
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                                    if (data.videoUrl.indexOf('mp4') !== -1) {
                                        $scope.video = data.videoUrl;
                                        clearInterval(timerId);
                                    }
                                });
                            }
                        }, checkTimeout);
                    }

                    getVideoUrl();

                    if ($scope.isVideo) {
                        $scope.status.showVideo = true;
                        return;
                    } else {
                        //   $scope.video = $scope.video;
                    }
                }
            },
        };
    },
]);
